import apiClient from './apiClient';
import { cleanParams } from '@/utils/buildQuery';

const base = '/admin/downloads';

export const downloadsService = {
  list: (params) => apiClient.get(base, { params: cleanParams(params) }),
  create: (payload) => apiClient.post(base, payload),
  update: (id, payload) => apiClient.patch(`${base}/${id}`, payload),
  remove: (id) => apiClient.delete(`${base}/${id}`),
};

export default downloadsService;
